import type { Row } from '@tanstack/react-table';
import { TableCell, TableRow } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';
import { flexRender } from '@tanstack/react-table';
import type { PractitionerDataError } from '@common/interfaces/api/practitionerDataErrorsApi';

type PractitionerTableRowProps = {
    row: Row<PractitionerDataError>;
};

export default function PractitionerTableRow({ row }: Readonly<PractitionerTableRowProps>) {
    const practitionerUrl = `/practitioners/${row.original.practitioner.id}/profile`;

    const navigate = useNavigate();

    return (
        <TableRow
            key={row.id}
            onClick={() => navigate(practitionerUrl, {})}
        >
            {row.getVisibleCells().map((cell) => (
                <TableCell key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</TableCell>
            ))}
        </TableRow>
    );
}
